import { Form } from "antd";
import styled, { css } from "styled-components";

import { Palette } from "../../../../core/styles/palette";

const baseStyle = css`
    // select nested div in aevi container that contains aevi label and form input
    &.aevi-form-field-horizontal div:has(> .aevi-form-field-label):has(> .aevi-form-field-input) {
        display: flex;
        flex-direction: row;
        gap: 15px;
    }

    // select nested div in aevi container that contains aevi label and form input
    &.aevi-form-field-vertical div:has(> .aevi-form-field-label):has(> .aevi-form-field-input) {
        display: flex;
        flex-direction: column;
        gap: 15px;
    }
`;

const formFieldStyle = css`
    &.aevi-form-field {
        gap: 15px;
        margin-bottom: 0;
    }

    // "required" asterix styling
    &.aevi-form-field .aevi-form-field-label {
        &:not(.aevi-form-field-label-no-derived-required):has(+ * [aria-required="true"])::after,
        &.aevi-form-field-label-required::after {
            content: " *";
            color: red;
            margin-left: 5px;
        }
    }

    &.aevi-form-field-label {
        // width configured in FormFieldRender
        font-family: "RobotoLight";
        font-size: 12pt;
        font-weight: 100;
        color: ${Palette.AeviBlack};
        text-align: right;
        //padding: 0 15px;
        line-height: 17pt;
        vertical-align: middle;
        overflow-x: hidden;
    }

    &.aevi-form-field-input {
        // width configured in FormFieldRender
        margin-top: auto;
        margin-bottom: auto;
    }

    &.aevi-form-field-horizontal {
        .aevi-form-field-label {
            //padding: 0 15px;
            width: 30%;
            text-align: right;
        }

        .aevi-form-field-input {
            width: 70%;
        }
    }

    &.aevi-form-field-vertical {
        .aevi-form-field-label {
            min-width: 100%;
            text-align: left;
            padding: 0;
        }

        .aevi-form-field-input {
            width: 100%;
        }
    }
`;

const ActionFormField = styled(Form.Item)`
    ${baseStyle};
    ${formFieldStyle};
`;

const ActionFormFieldDiv = styled.div`
    ${formFieldStyle};
    ${baseStyle};
`;

export const HorizontalFormFieldStyle = styled(ActionFormField).attrs(() => ({
    className: "aevi-form-field aevi-form-field-horizontal",
}))<{ hiddenLabel?: boolean; wideInput?: boolean }>`
    ${({ hiddenLabel }) => hiddenLabel && "display: none;"}
    ${({ wideInput }) =>
        wideInput &&
        css`
            // Col span here is 20/24 instead of the usual 14/24, so 21:79 keeps the label at the
            // same absolute width as a normal field's 30% of 14/24 (0.30 * 14/24 = 0.21 * 20/24).
            // Selectors need &.aevi-form-field-horizontal to out-specificity the base 30%/70% rule
            // above (two classes there vs one here would otherwise lose regardless of order).
            &.aevi-form-field-horizontal .aevi-form-field-label {
                width: 20.5%;
            }
            &.aevi-form-field-horizontal .aevi-form-field-input {
                width: 48%;
            }
        `}
`;

export const VerticalFormFieldStyle = styled(ActionFormField).attrs(() => ({
    className: "aevi-form-field aevi-form-field-vertical",
}))``;

export const VerticalFormFieldStyleDiv = styled(ActionFormFieldDiv).attrs(() => ({
    className: "aevi-form-field aevi-form-field-vertical",
}))``;

export const FormFieldInputStyle = styled(ActionFormField).attrs(() => ({
    className: "aevi-form-field-input",
}))``;

export const FormFieldLabelStyle = styled.label.attrs(() => ({ className: "aevi-form-field-label" }))`
    ${formFieldStyle};
`;

// antd hides its label colon in vertical layout; show it so search and drawer form labels match the form field labels.
// Items that opt out with colon={false} keep antd's "no-colon" class and stay without it.
export const VerticalFormLabelColonStyle = styled.div`
    .ant-form-vertical .ant-form-item-label > label:not(.ant-form-item-no-colon)::after {
        visibility: visible;
    }
`;
